import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import WhyChooseMe from "@/components/site/WhyChooseMe";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import LeadMagnet from "@/components/site/LeadMagnet";
import { ContactModalProvider } from "@/components/site/ContactModalContext";

const Site = () => {
  return (
    <ContactModalProvider>
      <div data-testid="site-root" className="min-h-screen bg-[#1A1918]">
        <Navigation />
        <main>
          <Hero />
          <About />
          <Services />
          <WhyChooseMe />
          <LeadMagnet />
          <Testimonials />
          <Contact />
        </main>
        <Footer />
      </div>
    </ContactModalProvider>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Site />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
